var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "container" }, [
    _c("div", { staticClass: "row margin-top" }, [
      _vm._m(0),
      _vm._v(" "),
      _c("div", { staticClass: "col-8 offset-2 background text-center" }, [
        _vm._v(
          "\n      The verification link used was not found in our records, or it was already used.\n      "
        ),
        _c("br"),
        _vm._v(" "),
        _c(
          "small",
          [
            _vm._v("You can try to "),
            _c(
              "router-link",
              { staticClass: "thick-font", attrs: { to: "login" } },
              [_vm._v("Login")]
            ),
            _vm._v(" or "),
            _c(
              "router-link",
              { staticClass: "thick-font", attrs: { to: "register" } },
              [_vm._v("Register")]
            )
          ],
          1
        )
      ]),
      _vm._v(" "),
      _vm._m(1)
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-8 offset-2" }, [
      _c("div", { staticClass: "row medium-font" }, [
        _c("div", { staticClass: "col-3" }, [
          _c("a", { attrs: { href: "#" } })
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "col-6 text-center" }, [
          _c("h3", [_c("strong", [_vm._v("Grow your business with mod24")])])
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "row big-font" }, [
        _c("div", { staticClass: "col text-center" }, [
          _c("p", [
            _c("strong", { staticClass: "text-danger" }, [
              _vm._v("\n              Verification not found\n            ")
            ])
          ])
        ])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-8 offset-2" }, [
      _c("div", { staticClass: "row" }, [
        _c("div", { staticClass: "col text-right" }, [
          _c("a", { staticClass: "thick-font", attrs: { href: "#" } }, [
            _vm._v("Need help?")
          ]),
          _c("br"),
          _vm._v(" "),
          _c("p", { staticClass: "info-text" }, [
            _vm._v("Visit our knowledge base")
          ])
        ])
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-0751bd1e", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0751bd1e","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/auth/VerificationNotFound.vue
// module id = null
// module chunks = 